/*
 * @@Author: MuYang
 */

import {batchHandleUrl} from '../../../utils/url-handle'

const Api = {
  // getPageRule: {
  //   url: '/apaas/rule/getPageRule',
  //   type: 'POST'
  // },
  // getRuleValue: {
  //   url: '/apaas/object/value/get/ruleValue',
  //   type: 'POST'
  // },
  // 获取对象 schema
  getLayoutInfo: {
    url: '/apaas/layout/get',
    type: 'post',
    processUrl ({tenantType, objectApiName, layoutApiName, listLayoutApiName, curAuthCode}) {
      return `${this.url}/${tenantType}/${objectApiName}/${listLayoutApiName ? `${listLayoutApiName}/` : ''}${layoutApiName}/${curAuthCode}`
    }
  },
  // 查找关联主从列设置
  getRelationLayoutDetail: {
    url: '/apaas_design/layout/getRelationLayoutDetail',
    type: 'post'
  },
  
  // 从对象列表
  apaasGetRelationLayoutDetail: {
    url: '/apaas/layout/getRelationLayoutDetail',
    type: 'post',
    processUrl ({tenantType, objectApiName, layoutApiName}) {
      return `${this.url}/${tenantType}/${objectApiName}/${layoutApiName}`
    },
    parmeter: {
      'objectApiName': String,
      'layoutApiName': String,
      'objectDependencyCode': String
    }
  },
  // 查找关联 关联对象
  getRelationLayoutByField: {
    url: '/apaas/layout/getLookUpRelationPage',
    type: 'post',
    processUrl ({tenantType, oneObjectApiName, listLayoutApiName}) {
      return `${this.url}/${tenantType}/${oneObjectApiName}/${listLayoutApiName}`
    }
  }
}

export default batchHandleUrl(Api)
// paas/layout/get/pur/object_tFGDkzIky/page_i4553wttiq/apaas_create